import { Link } from "react-router";

import { PRODUCT_NAME } from "utilities/productName";

export default function Experiments() {
  // TODO: Make this look nicer
  return (
    <article className="pa3 pa5-ns helvetica">
      <h1 className="f3 f2-m f1-l">Experiments</h1>
      <p className="measure lh-copy mb0">
        Congratulations, you've found our secret lab. Below are links to
        standalone demos we've created to quickly try out ideas.
      </p>

      <p className="measure lh-copy mb0">
        If you're looking for {PRODUCT_NAME}, <a href={"/"}>click here!</a>
      </p>

      <ul className="list pl0 mt0">
        <li className="pa3 pa4-ns">
          <Link to="/experiments/dataset-creator">
            <b className="db f3 mb1 link">galileo dataset creator</b>
          </Link>
          <p className="f5 db lh-copy measure">
            Experimental tool to help create OpenLineage dataset events from
            user-provided plaintext descriptions.
          </p>
        </li>
      </ul>
    </article>
  );
}
